module.exports = __webpack_public_path__ + "media/images/abertura-78f42373d2351e5439872106d8425191.jpg";